'use strict'

/**
 * Pause all videos expect specific video if video element provided
 * @param {DOM} element
 */
const pauseVideos = (element = null) => {
  try {
    const videos = document.querySelectorAll('video')

    for (let idx = 0; idx < videos.length; idx++) {
      // skip for the current video to plays
      if (element && videos[idx] === element) {
        continue
      }

      // Have we already played it && is it already paused?
      if (videos[idx].played.length > 0 && !videos[idx].paused) {
        // Then pause it now
        videos[idx].pause()
      }
    }
  } catch (err) {
    console.error('Video Pause error', err)
  }
}

export default {
  pauseVideos
}
